import { useSelector } from '../../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../../app.store';

export const boundaryFormTypeSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.type;
export const useBoundaryFormType = () => useSelector(boundaryFormTypeSelector);

const boundaryFormModeSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryForm.mode;
export const useBoundaryFormMode = () => useSelector(boundaryFormModeSelector);
